export default "__VITE_ASSET__ByBuAYNW__"